// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faPlus, faMinus, faCaretLeft, faCaretRight, faClock, faCookieBite, faLocationDot, faMapMarkerAlt, faScroll, faComments, faBasketShopping, faCakeCandles } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
library.add(faPlus, faMinus, faCaretLeft, faCaretRight, faClock, faCookieBite, faLocationDot, faMapMarkerAlt, faScroll, faComments, faBasketShopping, faCakeCandles, faFacebook, faInstagram);
dom.watch();

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import cart from './routes/cart';
//import home from './routes/home';
//import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  cart,
  // Home page
//  home,
  // About Us page, note the change from about-us to aboutUs.
//  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js